module.exports = __webpack_public_path__ + "ba04bf2e4f9a59f25d91c23031d72797.MP3";